/**
 * Para alacağı bağlamı olmayan takip türlerinde BSMV alanı gösterilmez (54, 56).
 */
export function takipteBsmvAlaniniGoster(
  takipTipiEskiNo: string | number | undefined | null
): boolean {
  if (takipTipiEskiNo === undefined || takipTipiEskiNo === null) {
    return true;
  }
  const s = String(takipTipiEskiNo);
  return s !== '54' && s !== '56';
}

/**
 * KDV, takipten sonra işleyecek faiz/fer'i kalemlerine yansıtıldığı için
 * BSMV ile aynı takip türlerinde gösterilir (54, 56 hariç).
 */
export function takipteKdvAlaniniGoster(
  takipTipiEskiNo: string | number | undefined | null
): boolean {
  return takipteBsmvAlaniniGoster(takipTipiEskiNo);
}
